import { getRawValue } from '../../../utils/get';
import { getAttendenceMode } from '../calculated/get-attendence-mode';
import { getLocation } from './get-location';
import { getJsonOffers } from './get-json-offers';
import { getMainImageUrl } from '../calculated/get-main-image-url';
export var renderStructureData = function (item, ticketLength) {
    var getItemData = function (path) { return getRawValue(item, path); };
    return {
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: getItemData('event.title'),
        description: getItemData('event.description'),
        startDate: getItemData('event.scheduling.config.startDate'),
        endDate: getItemData('event.scheduling.config.endDate'),
        eventStatus: "https://schema.org/" + getItemData('event.status'),
        eventAttendanceMode: "https://schema.org/" + getAttendenceMode(item),
        Location: getLocation(item),
        offers: getJsonOffers(item, ticketLength),
        image: {
            '@type': 'ImageObject',
            url: getMainImageUrl(item),
            width: getItemData('event.mainImage.width'),
            height: getItemData('event.mainImage.height'),
        },
    };
};
